export default __webpack_public_path__ + "static/media/people-group.f67facfc.svg";